import '../../styles/Nosotros/nosotrosServicios.scss';
import out  from '../../assets/outsourcing.svg';
import talentos  from '../../assets/talentos-nos.svg';
import capacitaciones  from '../../assets/capacitaciones-nos.svg';
import consultoria  from '../../assets/consultoria-nos.svg';

export const NosotrosServicios = () => {
    return (
        <div className="nosotros-servicios">
        <div className="nosostros-servicios-container">
            <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-easing="ease-out" className="title">
                Nuestros Servicios
            </h2>
            <div className="card-grid">
                <div data-aos="flip-left" data-aos-delay="100" data-aos-duration="1000" data-aos-easing="ease-out" className="card">
                    <img src={talentos} alt="icon 1" className="card-icon" />
                    <h3 className="card-title">Atracción de talentos</h3>
                    <p className="card-description">
                        Captamos y reclutamos a los mejores profesionales mediante estrategias efectivas para conectar empresas con candidatos altamente calificados.
                    </p>
                </div>
                <div data-aos="flip-left" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-out" className="card">
                    <img src={capacitaciones} alt="icon 2" className="card-icon" />
                    <h3 className="card-title">Capacitaciones</h3>
                    <p className="card-description">
                        Te ayudamos a desarrollar habilidades claves mediante programas de formación que mejoran el rendimiento y potencian el éxito de tu proyecto.
                    </p>
                </div>
                <div data-aos="flip-left" data-aos-delay="300" data-aos-duration="1000" data-aos-easing="ease-out" className="card">
                    <img src={consultoria} alt="icon 3" className="card-icon" />
                    <h3 className="card-title">Consultoría de capital humano</h3>
                    <p className="card-description">
                        Asesoramos en la gestión del talento para mejorar procesos y estrategias, maximizando el potencial de tu equipo.
                    </p>
                </div>
                <div data-aos="flip-left" data-aos-delay="400" data-aos-duration="1000" data-aos-easing="ease-out" className="card">
                    <img src={out} alt="icon 4" className="card-icon" />
                    <h3 className="card-title">Outsourcing</h3>
                    <p className="card-description">
                        Nos encargamos de la selección, desarrollo y retención del talento, permitiéndote concentrar en el crecimiento de tu negocio.
                    </p>
                </div>
            </div>
        </div>
    </div>
    );
};

export default NosotrosServicios;